import React from 'react';
import { LinkButton } from 'app/blocks/buttons/buttons';
import { ID, withCodes } from 'app/blocks/common/codes';
import { useArticlePage } from 'app/pages/article/ArticlePage.context';
import DefaultActions from '../actions';
import { BasicView, GrayView } from '../views/WidgetView';

const panel = 'OAOrder';

function OAOrder({ l }: { l: l }): React.ReactElement {
    const item = useArticlePage();
    const { hasRequired, getTitle, getStatus, getActions, getAllActions, hasCitations, hasImportant, getIcon } =
        item.helpers;

    const downloadInvoiceLink = getActions(panel).DOWNLOAD_INVOICE;

    const View = item.status.published && !hasRequired(panel) && hasCitations() ? GrayView : BasicView;

    const { article, journal } = item;

    return (
        <View
            actions={<DefaultActions buttons={getAllActions(panel, {}, { article, journal })} />}
            additionalActions={
                downloadInvoiceLink && (
                    <LinkButton
                        data-seleniumid="INVOICE_HELP"
                        href={l('WIDGETS.INVOICE_HELP_URL')}
                        isLinkTag
                        target="_blank"
                    >
                        {l('WIDGETS.INVOICE_HELP')}
                    </LinkButton>
                )
            }
            icon={getIcon(panel, 'payOA')}
            required={hasRequired(panel) || hasImportant(panel)}
            seleniumid="OAOrder"
            title={getTitle(panel)}
        >
            {getStatus(panel)}
        </View>
    );
}

export default withCodes(OAOrder, ID.WIDGETS);
